import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const TooltipPortal = ({ children, show }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted || !show) return null;

  return ReactDOM.createPortal(
    children,
    document.body
  );
};

export default TooltipPortal;

